<div class="tw-flex tw-flex-col tw-gap-4 tw-text-right">
  <h5 class="tw-m-0 smsir-h5-lg tw-text-[rgb(var(--text-primary))]">
    {{ modalHeader }}
  </h5>

  <p class="tw-m-0 smsir-helper-lg tw-whitespace-pre-wrap tw-text-[rgb(var(--text-secondary))]">
    {{ modalText }}
  </p>

  <div class="tw-mb-4 tw-mt-2 tw-flex tw-w-full tw-justify-end tw-gap-2 max-md:tw-grid max-md:tw-grid-cols-2">
    <button
      smsir-button
      type="button"
      variant="text"
      size="sm"
      class="tw-min-w-0 md:tw-w-auto"
      (click)="onCancel()"
    >
      {{ modalCancelButton || 'لغو' }}
    </button>

    <button
      smsir-button
      type="button"
      variant="primary-destructive"
      size="sm"
      class="tw-min-w-0 md:tw-w-auto"
      (click)="onSubmit()"
    >
      {{ modalConfirmButton || 'حذف' }}
    </button>
  </div>
</div>
